/* tslint:disable:no-trailing-whitespace */
import {Component, OnInit} from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import * as Highcharts from 'highcharts';
import * as Exporting from 'highcharts/modules/exporting';
import {MessageSeriesSelected} from '../../messages/message-series-selected';
import {DataSeries} from '../../DoraData/data-series';
import {CHART_TYPE} from '../../DoraData/data-base';
import {MessageChartType} from '../../messages/message-chart-type';
import {DoraProperty, DoraPropertyArray} from '../../Decorators/Decorator';
import {ChartOption} from './Data/chart-option';
import {ChartBuilder} from './chart-builder';
import {MessageChartPrint} from '../../messages/message-chart-print';
import {HttpHeaders} from '@angular/common/http';
import {ChartStockBuilder} from './chart-stock-builder';
import {MessageSeriesTypeSelected} from '../../messages/message-series-type-selected';
import {SeriesSelectorType} from '../dora-series-selector/data/series-selector-type';
import {PositionElement} from '../../Utility/position-element';
import {MessageRowsUnselected} from '../../messages/message-rows-unselected';
import {DataRow} from '../../DoraData/data-row';

declare function extGetAppConfigurationPath(): string;

// @ts-ignore
Exporting(Highcharts);

// declare function printAllCharts(): void;

@Component({
  selector: 'dora-chart',
  templateUrl: './dora-chart.component.html',
  styleUrls: ['./dora-chart.component.scss']
})
// todo manca PIE_COLUMNGROUP
export class DoraChartComponent extends WidgetBaseComponent implements OnInit {
  @DoraProperty
  private defaultType = '';
  @DoraProperty
  private title = '';

  @DoraProperty
  private useSeriesTitle = false;

  // with break point
  @DoraProperty
  private widthBreak = 0;

  @DoraProperty
  private showTitle = true;

  @DoraProperty
  private customToolTip = true;

  @DoraProperty
  private customToolTipShowPercentageFromFirst = false;

  @DoraProperty
  private outputFormat = '#.#';

  @DoraProperty
  private outputFormatFromData = true;

  // Set options Highcharts.chart.chart
  @DoraPropertyArray (ChartOption)
  private chart: ChartOption[] = [];

  // Set options Highcharts.chart.legend
  @DoraPropertyArray (ChartOption)
  private legend: ChartOption[] = [];

  // Set options Highcharts.chart.tooltip
  @DoraPropertyArray (ChartOption)
  private tooltip: ChartOption[] = [];

  // Set options Highcharts.chart.plotOptions.pie
  @DoraPropertyArray (ChartOption)
  private piePlotOptions: ChartOption[] = [];

  // Option for pie chart with widthBreak
  @DoraPropertyArray (ChartOption)
  // tslint:disable-next-line:variable-name
  private Wp_piePlotOptions: ChartOption[] = [];

  // Set options Highcharts.chart.plotOptions.column
  @DoraPropertyArray (ChartOption)
  private columnPlotOptions: ChartOption[] = [];

  // Set options Highcharts.chart.plotOptions.column
  @DoraPropertyArray (ChartOption)
  private columnStackPlotOptions: ChartOption[] = [];

  // Set options Highcharts.chart.plotOptions.line
  @DoraPropertyArray (ChartOption)
  private linearPlotOptions: ChartOption[] = [];

  // Set options Highcharts.chart.plotOptions.line
  @DoraPropertyArray (ChartOption)
  private splinePlotOptions: ChartOption[] = [];

  // Set options Highcharts.chart.plotOptions.bar
  @DoraPropertyArray (ChartOption)
  private barPlotOptions: ChartOption[] = [];

  // Set options Highstock.chart.plotOptions
  @DoraPropertyArray (ChartOption)
  private stockPlotOptions: ChartOption[] = [];

  // Set options Highcharts.chart.navigator
  @DoraPropertyArray (ChartOption)
  private navigator: ChartOption[] = [];

  // Set options Highcharts.chart.scrollbar
  @DoraPropertyArray (ChartOption)
  private scrollbar: ChartOption[] = [];

  // Set options Highcharts.chart.rangeSelector
  @DoraPropertyArray (ChartOption)
  private rangeSelector: ChartOption[] = [];

  // axis
  @DoraPropertyArray (ChartOption)
  private xAxis: ChartOption[] = [];
  @DoraPropertyArray (ChartOption)
  private yAxis: ChartOption[] = [];

  // yrange in percentage
  @DoraProperty
  private yRangeMaxPercentage = 0.0;
  @DoraProperty
  private yRangeMinPercentage = 0.0;

  // Set options Highcharts.chart.series
  @DoraPropertyArray (ChartOption)
  private seriesPlotOptions: ChartOption[] = [];


  private graphSkinConfiguration: any = undefined;
  private chartType: CHART_TYPE = null;
  // private Highcharts: typeof Highcharts[] = [];

  private seriesSelectorType: SeriesSelectorType = null;

  protected chartBuilders: ChartBuilder[];

  protected chartStockBuilders: ChartStockBuilder[];

  updateFromInput = false;

  // show charts on popoup: it receives PositionElement from series
  @DoraProperty
  protected showOnPopup = false;

  protected popupVisible = false;

  // Position of caller. Necessary to show popup
  private callerPosition: PositionElement = null;

  private chartOptions: Highcharts.Options = {
    chart: {
      type: 'column',
      marginRight: 200
    },
    credits: {
      enabled: false
    },
    title: {
      text: 'primo chart'
    },
    series: [
      {
        data: [1, 2, 3],
        type: 'column',
        name: 'test'
      },
      {
        data: [2, 3, 4],
        type: 'column',
        name: 'test2'
      }    ]
  };

  private seriesList: DataSeries[] = [];

  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    // ChartType
    this.setChartTypeFromString(this.defaultType);
    // load GraphSkin
    this.http.get(extGetAppConfigurationPath() + '/GraphSkin.json').subscribe(
      (data: string) => {
        this.graphSkinConfiguration = data;
        this.readData();
      });

    this.setEvents();
  }
  onRefresh(): void {
    super.onRefresh();
    this.readData();
  }

  /**
   * Set all events listening
   */
  private setEvents(): void {
    // EVENTS

    // EVENT MessageSeriesSelected
    this.messageService.getMessage(this.EventChannel, MessageSeriesSelected, this.CallerName).subscribe(message => {
      this.seriesList = (message.data as MessageSeriesSelected).DatasSeries;

      // enable popup
      if (this.showOnPopup) {
        // check if there is one series at least
        if (this.seriesList.length === 0) {
          this.popupVisible = false;
          return;
        }

        this.callerPosition = (message.data as MessageSeriesSelected).CallerPosition;
        this.popupVisible = true;
      }

      this.readData();
    });

    // EVENT MessageChartType
    this.messageService.getMessage(this.EventChannel, MessageChartType, this.CallerName).subscribe(message => {
      this.chartType = (message.data as MessageChartType).chartType;

      this.readData();
    });

    // EVENT MessageSeriesTypeSelected
    this.messageService.getMessage(this.EventChannel, MessageSeriesTypeSelected, this.CallerName).subscribe(message => {
      this.seriesSelectorType = (message.data as MessageSeriesTypeSelected).seriesSelectorType;

      this.readData();
    });

    // EVENT MessageChartPrint
    this.messageService.getMessage(this.EventChannel, MessageChartPrint, this.CallerName).subscribe(message => {
      this.onPrint((message.data as MessageChartPrint).outputType);
    });
  }

  private setChartTypeFromString(src: string): void {
    if (src === null || src === undefined || src === '') {
      this.chartType = undefined;
      return;
    }

    this.chartType = CHART_TYPE[src.toUpperCase()];

    if (this.chartType === undefined) {
      console.error('CHARTTYPE ' + src + ' not allowed');
      return;
    }
  }

  private readData(): void {

    if (this.chartType === null || this.chartType === undefined ||
      this.seriesList === null || this.seriesList === undefined || //  this.seriesList.length === 0 ||
      this.graphSkinConfiguration === undefined) {
      return;
    }

    // set default from GraphSkin
    this.chartOptions = this.graphSkinConfiguration;

    this.chartOptions.series = [];


    const seriesLists: DataSeries[][] = [];
    // set plot options
    if (this.chartOptions.plotOptions === undefined) {
      this.chartOptions.plotOptions = {};
    }
    let plotOptionsForType: ChartOption[] = [];

    // check if with break point is reached
    let flUseWp = false;
    if (this.widthBreak !== 0 && window.innerWidth < this.widthBreak) {
      flUseWp = true;
    }

    switch (this.chartType) {
      case CHART_TYPE.STOCKLINEAR:
      case CHART_TYPE.STOCKAREA:
      case CHART_TYPE.STOCKAREASPLINE:
        seriesLists.push(this.seriesList);
        break;
      case CHART_TYPE.COLUMNSTACK:
        plotOptionsForType = this.columnStackPlotOptions;
        seriesLists.push(this.seriesList);
        break;
      case CHART_TYPE.COLUMN:
        plotOptionsForType = this.columnPlotOptions;
        seriesLists.push(this.seriesList);
        break;
      case CHART_TYPE.BAR:
        plotOptionsForType = this.barPlotOptions;
        seriesLists.push(this.seriesList);
        break;
      case CHART_TYPE.LINEAR:
        plotOptionsForType = this.linearPlotOptions;
        seriesLists.push(this.seriesList);
        break;
      case CHART_TYPE.SPLINE:
        plotOptionsForType = this.splinePlotOptions;
        seriesLists.push(this.seriesList);
        break;
      case CHART_TYPE.PIE:
        plotOptionsForType = flUseWp ? this.Wp_piePlotOptions : this.piePlotOptions;
        this.useSeriesTitle = true;

        // push a serieslist for each serie
        this.seriesList.forEach((series: DataSeries) => {
          const seriesList: DataSeries[] = [];
          seriesList.push(series);
          seriesLists.push(seriesList);
        });
        break;
    }

    this.chartBuilders = [];
    this.chartStockBuilders = [];
    if (this.chartType === CHART_TYPE.STOCKLINEAR ||
      this.chartType === CHART_TYPE.STOCKAREA ||
      this.chartType === CHART_TYPE.STOCKAREASPLINE) {
      // Use StockChart
      plotOptionsForType = this.stockPlotOptions;

      seriesLists.forEach((seriesList: DataSeries[]) => {
        let myTitle: string;

        if (this.showTitle === false) {
          myTitle = '';
        } else if (this.useSeriesTitle) {
          myTitle = seriesList[0].Description;
        } else {
          myTitle = this.title;
        }

        this.chartStockBuilders.push(new ChartStockBuilder(this.chartType,
          JSON.stringify(this.graphSkinConfiguration),
          this.filterDataBySeriesSelectorType(seriesList),
          this.chart,
          this.legend,
          this.tooltip,
          this.scrollbar,
          this.navigator,
          this.rangeSelector,
          this.locale,
          this.xAxis, this.yAxis,
          this.yRangeMaxPercentage,
          this.yRangeMinPercentage,
          plotOptionsForType,
          this.seriesPlotOptions,
          myTitle,
          this.customToolTip,
          this.customToolTipShowPercentageFromFirst,
          this.outputFormat,
          this.outputFormatFromData));
      });


      this.updateFromInput = true;

    } else {
      // Use Chart
      seriesLists.forEach((seriesList: DataSeries[]) => {
        let myTitle: string;

        if (this.showTitle === false) {
          myTitle = '';
        } else if (this.useSeriesTitle) {
          myTitle = seriesList[0].Description;
        } else {
          myTitle = this.title;
        }

        this.chartBuilders.push(new ChartBuilder(this.chartType,
          JSON.stringify(this.graphSkinConfiguration),
          seriesList,
          this.chart,
          this.legend,
          this.tooltip,
          this.locale,
          this.xAxis, this.yAxis,
          plotOptionsForType,
          myTitle,
          this.customToolTip,
          this.outputFormat,
          this.outputFormatFromData));
      });


      this.updateFromInput = true;
    }
  }

  private filterDataBySeriesSelectorType(seriesList: DataSeries[]): DataSeries[] {
    if (this.seriesSelectorType === null || this.seriesSelectorType === undefined
      || this.seriesSelectorType.dateRange === null
      || this.seriesSelectorType.dateRange === undefined) {
      return seriesList;
    }

    // date range set: filter data
    const result: DataSeries[] = [];

    seriesList.forEach((series: DataSeries) => {

      // skip series fixed
      if (series.FixedSeries) {
        return;
      }

      const seriesFiltered = series.filterByDateRange(this.seriesSelectorType.dateRange);

      // set first value if dateRange is not present
      if (this.seriesSelectorType.dateRange === null || this.seriesSelectorType.dateRange === undefined) {
        seriesFiltered.FirstValue = series.FirstValue;
      }
      result.push(seriesFiltered);
    });

    return result;
  }
  private toolTipFormatter(): false | string | Array<string> {
    return 'ciao';
  }

  private onPrint(outputType: string): void {
    console.log('print');
    // this.chartBuilders.reverse().forEach(chartBuilder => {
    //   chartBuilder.export(outputType);
    //   console.log('print finished');
    // });

    const svgArr: string[] = [];
    let top = 0;
    let chartWidth = 0;
    let chartIdx = 0;
    this.chartBuilders.reverse().forEach(chartBuilder => {
      let svg = chartBuilder.getSVG(chartIdx);
      chartIdx++;

      const svgWidth = +svg.match(
          /^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/
      )[1];

      const svgHeight = +svg.match(
              /^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/
          )[1];
      svg = svg.replace(
          '<svg',
          '<g transform="translate(0,' + top + ')" '
      );
      svg = svg.replace('</svg>', '</g>');

      top += svgHeight;
      chartWidth = Math.max(chartWidth, svgWidth);

      svgArr.push(svg);
    });

    // build complete SWG
    const completeSVG = '<svg height="' + top + '" width="' + chartWidth +
        '" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
        svgArr.join('') + '</svg>';

    // get generic options
    const options = Highcharts.getOptions().exporting;

    const myHeaders = new HttpHeaders();
    myHeaders.set('Content-Type', outputType);
    myHeaders.set('Accept', 'text/plain, */*');
    myHeaders.set('Cache-Control', 'no-cache');
    this.http.post(options.url,
        {filename: options.filename || 'chart',
        type: outputType,
        width: chartWidth,
        svg: completeSVG},
        {headers: myHeaders, responseType: 'blob'}
        ).subscribe(value => {
          this.downLoadFile(value, outputType);
          console.log('chiamata effettuata');

    },
        err => {
          console.log('errore');
          this.downLoadFile(err.error.text, outputType);
        });
    // printAllCharts();
  }
  private downLoadFile(data: any, type: string) {
    const blob = new Blob([data], { type});
    const url = window.URL.createObjectURL(blob);
    console.log('Open url ' + url.toString());
    const pwa = window.open(url);
    // tslint:disable-next-line:triple-equals
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      alert( 'Please disable your Pop-up blocker and try again.');
    }
  }

  getPopupVisibility(): string   {
    return this.popupVisible ? 'visible' : 'hidden';

  }

  onPopupClose() {
    this.popupVisible = false;

    // build a list of idrows involved
    const idRows: string[] = [];
    this.seriesList.forEach((series: DataSeries) => {
      if (series.IdRowsOrigin !== null) {
        // merge arrays
        idRows.push(...series.IdRowsOrigin);
      }
    });

    // send message to deselect rows
    this.messageService.sendMessage(this.EventChannel, new MessageRowsUnselected(idRows), this.CallerName);
  }

  getPositionTop() {
    if (this.callerPosition === null) {
      return '100px';
    } else {
      return this.callerPosition.Top + 'px';
    }
  }

  getPositionLeft() {
    if (this.callerPosition === null) {
      return '100px';
    } else {
      return this.callerPosition.Left + 100 + 'px';
    }
  }
}
